import { render, staticRenderFns } from "./ActivateSubscriptionPage.vue?vue&type=template&id=8c097c06&scoped=true&"
import script from "./ActivateSubscriptionPage.vue?vue&type=script&lang=ts&"
export * from "./ActivateSubscriptionPage.vue?vue&type=script&lang=ts&"
import style0 from "./ActivateSubscriptionPage.vue?vue&type=style&index=0&id=8c097c06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c097c06",
  null
  
)

export default component.exports